import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

/**
 * PreviewBanner - Shows preview mode indicator
 */
export const PreviewBanner = () => (
  <Alert
    severity="info"
    icon={<VisibilityIcon />}
    sx={{ mb: 2, borderRadius: 2 }}
  >
    <AlertTitle sx={{ fontWeight: 600 }}>Modo Preview</AlertTitle>
    Esta é uma visualização prévia. As alterações na configuração são refletidas em tempo real.
    Nenhum log de acesso é gerado durante o preview.
  </Alert>
);
